module.exports = __webpack_public_path__ + "static/media/57808f1baef5613ae7430addef0ae850.57808f1b.webp";